<template>
  <br>
</template>

<script>
import { LOGOUT } from '@/store/action.types'
import { API_URL } from '@/common/config'
export default {
  data() {
    return {}
  },
  async created() {
    this.$vs.loading()
    this.$store
      .dispatch(LOGOUT)
      .then(() => {
        this.$vs.loading.close()
        this.$acl.change('public')
        console.log('logout on front redirect to kontur logout')
        window.location.href = API_URL + '/logout'
      })
  }
}
</script>
